/**
 * global context helper for Values from server side and push to store.
 */
import {
  BASE_URL,
  API_URL,
  CONTEXT_API,
  HOME_CONTEXT_API,
  PAP_CONTEXT_API,
  QJG_CONTEXT_API,
  ROUTES,
  RSA_CONTEXT_API,
  GET_COMPANIES_API,
  CATEGORY_PGID
} from "../../constants";
import FetchHelper from "../FetchHelper";
import formurlencoded from "form-urlencoded";

import { updateJob, updateRsaData } from "../../actions/JobActions";
import { updateApply } from "../../actions/ApplyActions";
import { updateUser } from "../../actions/UserActions";
import {
  updateContext,
  updateApplyAfterCityChange,
  updateApplyAfterLocalityChange,
  toggleSearchPopupFilter,
  toggleLoader
} from "../../actions/ContextActions";
import { updateJobSearchList } from "../../actions/JobSearchActions";
import Config from "../Config";
import JobsPostAdRequest from "../JobsPostAd/jobsPostAdRequest";
import root from "window-or-global";
import store, { JobStore } from "../../store";
import ApplyCookieHelper from "../Apply/ApplyCookieHelper";
import { capitalizeFirstLetter, sanitizeRole } from "../index";
import Cookies from "universal-cookie";
import {
  IncludeWebsiteUrl,
  IncludeMobileNumber
} from "../JobsPostAd/others/includeMobileUrl";
import UnlimitedFreeAds from "../JobsPostAd/others/unlimitedFreeAd";
import { RoleSubRole, CityOptions } from "../JobsPostAd/others/otherFeatures";
import UserUtil from "../User";
import ApplyService from "../../utils/Apply/ApplyService";
import Apply from "../../utils/Apply";
import { reduxActionIntegrationUpdateFormState } from "../../actions/IntegrationsActions";
import { updateCompany } from "../../actions/CompanyActions";

export default class Context {
  constructor() {
    this.fetchHelper = new FetchHelper();
  }

  initializeContextForHome = (ssr = false, dispatch = null, cookies = null) => {
    if (!dispatch) {
      dispatch = store.dispatch;
    }
    const dispatchPromises = [];

    if (!cookies) {
      cookies = new Cookies();
    }

    let url;
    if (ssr) {
      url = __JOBS_BAAHUBALI_PREFIX__ + BASE_URL + HOME_CONTEXT_API;
    } else {
      url = BASE_URL + HOME_CONTEXT_API;
    }
    const fetchHelper = new FetchHelper();
    const options = {
      url,
      includeCredentials: true
    };
    const contextPromise = fetchHelper.request("GET", options);
    return this.handleContextForHomePromise(
      contextPromise,
      dispatch,
      ssr,
      cookies
    );
  };

  handleContextForHomePromise = (
    contextPromise,
    dispatch,
    ssr = false,
    cookies
  ) => {
    let city = null;
    if (ssr) {
      city = cookies["new_prefer_city"];
    } else {
      city = cookies.get("new_prefer_city");
    }
    let updatedContext = { city };

    return contextPromise.then(apiResponse => {
      let response = apiResponse.data ? apiResponse.data : {};
      if (response.success) {
        if (response.json.redirectUrl) {
          if (root.location) {
            root.location.href = response.json.redirectUrl;
            return;
          }
        }

        const dispatchPromises = [];
        dispatchPromises.push(dispatch(updateUser(response.json.userDetails)));
        updatedContext = Object.assign(updatedContext, {
          roleCount: response.json.roleCount,
          isInternationalCity: response.json.isInternationalCity,
          cityRoleConfigsForGuaranteedJob:
            response.json.cityRoleConfigsForGuaranteedJob,
          jobsMonopolyConfig: response.json.jobsMonopolyConfig,
          localStorageCacheBurstingDetails:
            response.json.localStorageCacheBurstingDetails,
          isQCashEnabled: response.json.isQCashEnabled,
          qCashDetails: response.json.qCashDetails,
          vapLandingUrlConfig: response.json.vapLandingUrlConfig,
          isCompanyLinksDisplayActive:
            response.json.isCompanyLinksDisplayActive,
          fullScreenBannerConfig: response.json.fullScreenBannerConfig,
          androidDownloadPopupConfig: response.json.androidDownloadPopupConfig
        });

        if (response.json.redirectUrl && root.location && root.location.href) {
          root.location.href = response.json.redirectUrl;
        }

        if (response.json.jobsPudoAdData) {
          updatedContext = Object.assign(updatedContext, {
            jobsPudoAdData: response.json.jobsPudoAdData
          });
        }

        updatedContext.homeContextUpdatedInStore = true;

        dispatchPromises.push(dispatch(updateContext(updatedContext)));
        return dispatchPromises;
      }
    });
  };

  initializeContext = (
    params,
    ssr = false,
    dispatch = null,
    cookies = null,
    queryParams = null
  ) => {
    let url;
    if (ssr) {
      url = __JOBS_BAAHUBALI_PREFIX__ + BASE_URL + CONTEXT_API;
    } else {
      url = BASE_URL + CONTEXT_API;
    }
    const fetchHelper = new FetchHelper();

    const paramString = formurlencoded(params);
    let queryString;

    if (queryParams) {
      queryString = queryParams + "&";
    } else if (
      root.location &&
      root.location.search &&
      root.location.search !== ""
    ) {
      queryString = root.location.search + "&";
    } else {
      queryString = "?";
    }

    const options = {
      url: url + queryString + paramString,
      includeCredentials: true
    };
    if (cookies) {
      options.cookies = cookies;
    }
    if (params.role) {
      this.updateJobSnow({ role: capitalizeFirstLetter(params.role) });
    }
    const contextPromise = fetchHelper.request("POST", options);
    return this.handleContextPromise(contextPromise, params, dispatch);
  };

  getRsaData = params => {
    let url = BASE_URL + RSA_CONTEXT_API;
    let fetchHelper = new FetchHelper();
    let paramString = "ad_id=" + String(params.jobId);
    let queryString =
      root.location && root.location.search && root.location.search !== ""
        ? root.location.search + "&"
        : "?";
    let options = {
      url: url + queryString + paramString
    };
    let contextPromise = fetchHelper.request("POST", options);
    contextPromise.then(apiResponse => {
      let response = apiResponse.data ? apiResponse.data : {};
      if (response.success) {
        store.dispatch(updateRsaData(response.json));
      }
    });
  };

  getCompanies = (data = {}, params = {}) => {
    let url = BASE_URL + GET_COMPANIES_API;
    let fetchHelper = new FetchHelper();
    let options = {
      url: url,
      params: params,
      data: formurlencoded(data)
    };
    let contextPromise = fetchHelper.request("POST", options);
    return contextPromise.then(apiResponse => {
      let response = apiResponse.data ? apiResponse.data : {};
      if (response.success) {
        let companies = JobStore.getState().company.companies;
        companies = companies.concat(response.json.results);
        const payload = {
          companies: companies,
          totalCount: response.json.totalCount,
          page: data.page
        };

        store.dispatch(updateCompany(payload));
      }
    });
  };

  /**
   * Remove the applied jobs from store
   */
  static filterJobs(jobs = false, updateStore = false) {
    let applyCookieHelper = new ApplyCookieHelper();
    let appliedJobs = applyCookieHelper.getAppliedJobs();
    let jobsList = null;

    // fetch jobs from store
    if (!jobs) {
      jobsList = JobStore.getState().jobSearch.jobs;
    } else {
      jobsList = jobs;
    }

    // from the list of jobs, remove the already applied jobs
    let i = jobsList.length;
    while (i--) {
      let job = jobsList[i];

      if (appliedJobs.indexOf(job.id.toString()) > -1) {
        // console.log('removing jobs ', job.id);
        jobsList.splice(i, 1);
      }
    }

    // update store if required
    if (updateStore) {
      store.dispatch(
        updateJobSearchList({
          jobs: jobsList,
          replaceJobs: true
        })
      );
    }

    return jobsList;
  }

  updateContextStoreValues(response, params, dispatch = null) {
    if (
      params &&
      params.jobId &&
      response &&
      response.jobJson &&
      response.jobJson.category_pgid != CATEGORY_PGID
    ) {
      location.href = location.protocol + "//quikr.com/";
      return;
    }
    const dispatchPromises = [];
    if (!dispatch) {
      dispatch = store.dispatch;
    }

    let applyCookieHelper = new ApplyCookieHelper();
    let appliedJobs = applyCookieHelper.getAppliedJobs();
    let updatedApply = {
      isExpressApplyEnabled: response.isExpressApplyEnabled,
      isQuickApplyEnabled: response.isQuickApplyEnabled,
      isSkipApplyEnabled: response.isSkipApplyEnabled,
      taskId: response.taskId,
      firstStepProfile: response.firstStepProfile,
      source: params.source ? params.source : "VAP",
      expressApplyErrorCode: response.expressApplyErrorCode,
      appliedJobs,
      newApplicationCount: response.newApplicationCount,
      isNewDesiredCityImplementationSupported:
        response.isNewDesiredCityImplementationSupported,
      discount: response.vipApplyDiscount,
      emailNonMandatoryConfig: response.emailNonMandatoryConfig,
      job: response.jobJson
    };

    let role =
      response.jobJson && response.jobJson.role
        ? response.jobJson.role
        : response.roleName;
    let city =
      response.jobJson && response.jobJson.cityName
        ? response.jobJson.cityName
        : response.cityName;
    let cityId =
      response.jobJson && response.jobJson.city
        ? response.jobJson.city
        : response.city;
    let stateId = response.stateId;

    let updatedContext = {
      vipPackInfo: response.vipPackInfo,
      recruitmentAssistInfo: response.recruitmentAssistInfo,
      classifiedConfig: response.classifiedConfig,
      isCallUnlockEnabled: response.isCallUnlockEnabled,
      role,
      city,
      cityId,
      stateId,
      promotionVIPData: response.promotionVIPData,
      cityRoleConfigsForGuaranteedJob: response.cityRoleConfigForGuaranteedJob,
      cityRoleConfigsForThirdPartyPromotion:
        response.cityRoleConfigsForThirdPartyPromotion,
      interstitialAdConfigs: response.interstitialAdConfigs,
      flyingCarpetAdConfig: response.flyingCarpetAdConfig,
      localStorageCacheBurstingDetails:
        response.localStorageCacheBurstingDetails,
      integrations: response.integrationsConfigs,
      fullScreenBannerConfig: response.fullScreenBannerConfig,
      jobsPudoAdData: response.jobsPudoAdData,
      candidateCallUnlockConfig: response.candidateCallUnlockConfig,
      isQCashEnabled: response.isQCashEnabled,
      qCashDetails: response.qCashDetails,
      crossCatConfig: response.crossCatConfig,
      vapLandingUrlConfig: response.vapLandingUrlConfig,
      isInterstialAdEnabled: response.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: response.isFlyingCarpetAdEnabled,
      showBeSafeBanner: response.showBeSafeBanner,
      androidDownloadPopupConfig: response.androidDownloadPopupConfig
    };

    const updatedJobSnow = {
      role,
      isInterstialAdEnabled: response.isInterstialAdEnabled,
      isFlyingCarpetAdEnabled: response.isFlyingCarpetAdEnabled
    };

    if (params.source === "SNB") {
      updatedContext.snbContextUpdatedInStore = true;
      updatedJobSnow.route = ROUTES.SNB;
    } else {
      updatedContext.vapContextUpdatedInStore = true;
      updatedJobSnow.route = ROUTES.VAP;
    }

    // update JobSnow with context values
    this.updateJobSnow(updatedJobSnow);

    dispatchPromises.push(dispatch(updateContext(updatedContext)));
    dispatchPromises.push(dispatch(updateUser(response.userDetails)));
    dispatchPromises.push(dispatch(updateApply(updatedApply)));
    dispatchPromises.push(dispatch(updateJob(response.jobJson)));
    dispatchPromises.push(
      dispatch(
        reduxActionIntegrationUpdateFormState(updatedContext.integrations)
      )
    );

    if ("SNB" === params.source && response.jobJson.id) {
      let ampApplyJob = Apply.getJobFromStore(response.jobJson.id);
      if (null === ampApplyJob) {
        dispatchPromises.push(
          dispatch(
            updateJobSearchList({
              jobs: [response.jobJson]
            })
          )
        );
      }
    }

    ApplyService.directApplyAd(params.source); // for apply coming from amp

    return dispatchPromises;
  }

  handleContextPromise(contextPromise, params, dispatch = null) {
    const self = this;

    return contextPromise.then(apiResponse => {
      let response = apiResponse.data ? apiResponse.data : {};
      if (response.success && response.json && !response.json.isInActiveJob) {
        return self.updateContextStoreValues(response.json, params, dispatch);
      } else if (
        response.success &&
        response.json.isInActiveJob &&
        response.json.snbUrl
      ) {
        if (response.json && response.json.snbUrl && root.location) {
          root.location.href = response.json.snbUrl;
        }
      } else if (response.success === false) {
        ApplyService.directApplyAd(params.source);
        if (params && "SNB" === params.source) {
          Apply.toggleJobListDisplay(true);
        } else {
          try {
            if (typeof JobsSentry !== "undefined" && params)
              JobsSentry.captureMessage(
                "Vap failed to fetch Ad! \nParams : " +
                  JSON.stringify(params) +
                  "\nResponse : " +
                  JSON.stringify(response)
              );

            if (root.location) {
              root.location.href = "/jobs/404";
            }
          } catch (error) {}
        }
      }
    });
  }

  initializeContextForPAP = () => {
    let url = BASE_URL + PAP_CONTEXT_API;
    url +=
      "?isRoleSubRoleOptionsRequired=" +
      !RoleSubRole.isOptionsStored() +
      "&isCityOptionsRequired=" +
      !CityOptions.isOptionsStored();

    let options = { url };
    let contextPromise = this.fetchHelper.request("GET", options);
    contextPromise.then(apiResponse => {
      let response = apiResponse.data ? apiResponse.data : {};
      if (response.success) {
        let store = JobStore.getState();
        Config.updateConfig(response.json.configs, store);
        JobStore.dispatch(
          updateUser(
            UserUtil.updateUserCompanyDetails(response.json.userDetails)
          )
        );

        let updatedContext = {
          localStorageCacheBurstingDetails:
            response.json.localStorageCacheBurstingDetails
        };
        JobStore.dispatch(updateContext(updatedContext));

        JobsPostAdRequest.updatePostAdRequestFromContext(response);
        // get global jobstore before calling static functions
        // so as to avoid getState call from inside the static functions
        store = JobStore.getState();
        IncludeWebsiteUrl.updatePrice(store);
        store = JobStore.getState();
        IncludeMobileNumber.updatePrice(store);
        store = JobStore.getState();
        UnlimitedFreeAds.updateDetails(store);
        RoleSubRole.updateOptionsFromContext(response);
        CityOptions.updateOptionsFromContext(response);
      }
    });
  };

  /**
   * Update JobSnow variable used for dfp ads
   */
  updateJobSnow(values) {
    if (root.JobSnow && typeof root.JobSnow !== "undefined") {
      root.JobSnow = Object.assign(root.JobSnow, values);
    }
  }

  static updateCityForLocality = event => {
    let city = event.target.innerText;
    JobStore.dispatch(updateApplyAfterCityChange(city));

    Context.updateLocalityForLocality("");
  };

  initializeContextForQJG = () => {
    let url = BASE_URL + QJG_CONTEXT_API;
    let options = {
      url
    };
    let contextPromise = this.fetchHelper.request("GET", options);
    contextPromise.then(apiResponse => {
      let response = apiResponse.data ? apiResponse.data : {};
      if (response.success) {
        let updatedContext = {
          localStorageCacheBurstingDetails:
            response.json.localStorageCacheBurstingDetails,
          cityRoleConfigForGuaranteedJob:
            response.json.cityRoleConfigForGuaranteedJob
        };
        JobStore.dispatch(updateContext(updatedContext));
        JobStore.dispatch(updateUser(response.json.userDetails));
      }
    });
  };

  static updateLocalityForLocality = value => {
    JobStore.dispatch(updateApplyAfterLocalityChange(value));
  };

  static toggleSearchPopupFilter = value => {
    JobStore.dispatch(toggleSearchPopupFilter(value));
  };

  static getDetailsForContext = (qCashDetails, context) => {
    let details = {};
    for (let key in qCashDetails) {
      if (qCashDetails.hasOwnProperty(key)) {
        let value = qCashDetails[key];
        if (context === value.productContext) {
          details = value;
          break;
        }
      }
    }

    return details;
  };

  static showLoader = () => Context.toggleLoader(true);

  static hideLoader = () => Context.toggleLoader(false);

  static toggleLoader = value => {
    JobStore.dispatch(toggleLoader(value));
  };

  static isInterstitialAdEnabled = (page, city) => {
    let isEnabled = false;
    let storeValues = JobStore.getState();
    let config = storeValues.context.interstitialAdConfigs;
    if (config) {
      let pageConfig = config[page];
      let formattedCity = sanitizeRole(city.toLowerCase());
      isEnabled =
        pageConfig.isComplete ||
        pageConfig.enabledCities.indexOf(formattedCity) > -1;
    }

    return isEnabled;
  };

  static isFlyingCarpetAdEnabled = (role, city) => {
    let isEnabled = false;
    let storeValues = JobStore.getState();
    let config = storeValues.context.flyingCarpetAdConfig;
    if (config) {
      let formattedCity = sanitizeRole(city.toLowerCase());
      let formattedRole = sanitizeRole(role.toLowerCase());

      let isRoleEnabled =
        config.areAllRolesEnabled ||
        config.enabledRoles.indexOf(formattedRole) > -1;
      let isCityEnabled =
        config.areAllCitiesEnabled ||
        config.enabledCities.indexOf(formattedCity) > -1;

      isEnabled = isRoleEnabled && isCityEnabled;
    }

    return isEnabled;
  };

  // initializeContextForFlexi = () => {}
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Context/index.js